import React, { Component } from "react";
import logo from "./logovoip.png";
export default class Logo extends Component {
  render() {
    return (
      <div className="logo">
        <img
          className="h-14 w-auto"
          src="https://www.comunikcrm.com/assets/img/comunik-voip.png"
          alt="Workflow"
        />
      </div>
    );
  }
}
